<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/3 xl:w-1/4 sm:w-full mb-3">
        <div
          class="vx-card p-5"
          :style="isSmallerScreen ? '' : `height: 580px`"
        >
          <vs-row
            vs-align="flex-start"
            vs-type="flex"
            vs-justify="center"
            class="mb-5"
          >
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
            >
              <b-button
                size="md"
                variant="primary"
                style="border-radius: 5px 0 0 5px"
                :style="
                  btn_show1
                    ? 'background: rgba(var(--vs-primary),1)!important; border-color: rgba(var(--vs-primary),1)!important; color: #ffffff'
                    : 'background: #F8F7FA; border-color: #F8F7FA; color:#4B465C;'
                "
                :pressed="btn_show1"
                class="w-full group-button-cam"
                @click="handleFileList(0)"
              >
                Search Data
              </b-button>
              <b-button
                size="md"
                variant="secondary"
                style="border-radius: 0 5px 5px 0"
                :style="
                  btn_show2
                    ? 'background: rgba(var(--vs-primary),1)!important; border-color: rgba(var(--vs-primary),1)!important; color: #ffffff'
                    : 'background: #F8F7FA; border-color: #F8F7FA; color:#4B465C;'
                "
                :pressed="btn_show2"
                class="w-full group-button-cam"
                @click="handleFileList(1)"
              >
                File List
              </b-button>
            </vs-col>
          </vs-row>

          <template v-if="!showFlieList">
            <v-select
              :options="deviceList"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              placeholder="Search device (plate)..."
              v-model="device"
              @search="searchDevice"
              class="mb-6"
            />
            <flat-pickr
              :disabled="disableDate"
              :config="{ dateFormat: 'Y-m-d', maxDate: maxDate }"
              style="width: 100%"
              placeholder="Select date ..."
              v-model="date"
            />
            <vs-button
              id="searchBtn"
              style="width: 100%"
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-search"
              class="pl-5 mt-1 vs-con-loading__container"
              @click="search"
              :disabled="disabledSearch"
            >
              Search
            </vs-button>
          </template>

          <template v-else>
            <div
              class="p-1 w-full skeleton-list"
              :class="isSmallerScreen ? 'mt-5' : 'mt-0'"
              v-if="loading"
            >
              <template v-if="!skeleton"> No File List</template>
              <template v-else>
                <b-skeleton
                  animation="fade"
                  width="100%"
                  class="mb-5"
                ></b-skeleton>
                <b-skeleton
                  animation="fade"
                  width="100%"
                  class="mb-5"
                ></b-skeleton>
                <div
                  :key="index"
                  v-for="(col, index) in 8"
                  style="margin-top: -5px"
                >
                  <b-skeleton
                    animation="fade"
                    type="avatar"
                    class="my-2 mr-2"
                    height="20px"
                    width="20px"
                    style="display: inline-block"
                  ></b-skeleton>
                  <b-skeleton
                    animation="fade"
                    width="60%"
                    class="my-3"
                    style="display: inline-block"
                  ></b-skeleton>
                </div>
              </template>
            </div>

            <div
              class="p-1 w-full h-full skeleton-list"
              :class="isSmallerScreen ? 'mt-5' : 'mt-0'"
              v-else
            >
              <vs-row type="flex" vs-justify="space-between" class="mb-5">
                <vs-col vs-w="12">
                  <vs-input
                    disabled
                    label="Date History"
                    class="w-full"
                    :value="date_selected"
                    size="small"
                  />
                </vs-col>
              </vs-row>
              <vs-row type="flex" vs-justify="space-between">
                <vs-col vs-w="6" class="pr-2">
                  <label>Time Start</label>
                  <flat-pickr
                    :config="{
                      enableTime: true,
                      enableSeconds: true,
                      noCalendar: true,
                      dateFormat: 'H:i:S',
                      time_24hr: true,
                      minuteIncrement: 1,
                      secondIncrement: 1
                    }"
                    style="width: 100%; padding: 0.4rem; font-size: 0.8rem"
                    placeholder="Select time ..."
                    v-model="time_start"
                  />
                </vs-col>
                <vs-col vs-w="6" class="pl-2">
                  <label>Time End</label>
                  <flat-pickr
                    :config="{
                      enableTime: true,
                      enableSeconds: true,
                      noCalendar: true,
                      dateFormat: 'H:i:S',
                      time_24hr: true,
                      minuteIncrement: 1,
                      secondIncrement: 1
                    }"
                    style="width: 100%; padding: 0.4rem; font-size: 0.8rem"
                    placeholder="Select time ..."
                    v-model="time_end"
                  />
                </vs-col>
              </vs-row>
              <vs-row
                vs-align="flex-start"
                vs-type="flex"
                vs-justify="center"
                class="mt-5"
              >
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="12"
                >
                  <b-button
                    size="sm"
                    variant="primary"
                    style="border-radius: 5px 0 0 5px"
                    :style="
                      btn_group1
                        ? 'background: rgba(var(--vs-primary),1)!important; border-color: rgba(var(--vs-primary),1)!important; color: #ffffff'
                        : 'background: #F8F7FA; border-color: #F8F7FA; color:#4B465C;'
                    "
                    :pressed="btn_group1"
                    class="w-full group-button-cam"
                    @click="handleCam(0)"
                  >
                    Cam 1
                  </b-button>
                  <b-button
                    :disabled="is_disable_cam2"
                    size="sm"
                    variant="secondary"
                    style="border-radius: 0 5px 5px 0"
                    :style="
                      btn_group2
                        ? 'background: rgba(var(--vs-primary),1)!important; border-color: rgba(var(--vs-primary),1)!important; color: #ffffff'
                        : 'background: #F8F7FA; border-color: #F8F7FA; color:#4B465C;'
                    "
                    :pressed="btn_group2"
                    class="w-full group-button-cam"
                    @click="handleCam(1)"
                  >
                    Cam 2
                  </b-button>
                </vs-col>
              </vs-row>
              <div
                class="mt-2"
                style="overflow-y: scroll"
                :style="
                  isSmallerScreen ? 'max-height: 50vh;' : 'max-height: 300px; '
                "
              >
                &nbsp;
                <vs-row v-for="(item, index) in filelist" :key="index">
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="left"
                    vs-w="12"
                  >
                    <div
                      class="w-full card-time pl-2 pr-2"
                      @click="handleCardClick(index)"
                      style="cursor: pointer"
                    >
                      <vs-card class="w-full mb-0">
                        <b-form-radio
                          name="radio-size"
                          style="font-weight: bold"
                          v-model="selectedTime"
                          :value="index"
                        >
                          {{ item.time }}
                        </b-form-radio>
                      </vs-card>
                    </div>
                  </vs-col>
                </vs-row>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="vx-col w-full lg:w-2/3 xl:w-3/4 sm:w-full dashcam-history">
        <vs-row
          vs-type="flex"
          vs-justify="space-between"
          :style="isSmallerScreen ? `height: 105vh` : `height: 75vh`"
          v-if="!skeleton"
        >
          <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-card class="p-1 w-full h-full">
              <div
                class="h-full"
                style="background: #f8f7fa; border-radius: 10px"
              >
                <vs-row class="w-full h-full">
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="4"
                    vs-sm="12"
                    class="p-md-5 p-0"
                  >
                    <img
                      class="w-full h-full px-5"
                      src="@/assets/images/freepik/no_history.svg"
                      alt="No Video"
                    />
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="center"
                    vs-w="8"
                    vs-sm="12"
                    class="px-3"
                  >
                    <vs-row>
                      <vs-col vs-w="12" class="mb-2">
                        <span class="font-weight-bold text-lg"
                          >Cek history dashcam.</span
                        >
                      </vs-col>
                      <vs-col vs-w="12">
                        <p class="text-secondary">
                          Untuk mulai melihat histori dashcam, pilih unit dan
                          tanggal terlebih dahulu ya.
                        </p>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                </vs-row>
              </div>
            </vs-card>
          </vs-col>
        </vs-row>
        <vs-row
          vs-type="flex"
          vs-justify="space-between"
          :style="isSmallerScreen ? `height: 93vh` : `height: 75vh`"
          v-else
        >
          <vs-col
            type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="8"
            vs-sm="12"
            v-if="loading"
            class="mb-3"
          >
            <vs-card class="p-1 w-full h-full">
              <b-skeleton-img
                no-aspect
                animation="fade"
                height="100%"
              ></b-skeleton-img>
            </vs-card>
          </vs-col>

          <vs-col
            type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="8"
            vs-sm="12"
            v-else
            class="mb-3"
          >
            <vs-card class="p-1 w-full h-full">
              <vs-row class="h-full w-full">
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="12"
                  class="w-full h-full"
                >
                  <fullscreen
                    :fullscreen.sync="fullscreen"
                    class="pt-2 h-full w-full bg-video position-relative"
                    style="border-radius: 8px"
                  >
                    <div
                      class="center-div w-full h-full"
                      v-show="isSmallerScreen"
                    >
                      <vs-row class="p-2">
                        <vs-col
                          vs-type="flex"
                          vs-justify="space-between"
                          vs-w="12"
                          class="w-full"
                        >
                          <vs-button
                            color="white"
                            text-color="#4B465C"
                            type="filled"
                            style="
                              font-size: 0.8em;
                              height: 25px;
                              line-height: 5pt;
                              padding-left: 15px;
                              padding-right: 15px;
                              padding-top: 10px
                              cursor: default;
                              margin-top: 5px;
                              background: #ffffff30;
                              color: #fff;
                            "
                            class="mx-1"
                          >
                            <span
                              class="font-weight-bold"
                              style="font-size: 1.1em"
                              >Time</span
                            >
                            <span> : {{ camera.timeSlider }}</span>
                          </vs-button>
                          <vs-button
                            color="white"
                            text-color="#4B465C"
                            type="filled"
                            style="
                              font-size: 0.8em;
                              height: 25px;
                              line-height: 5pt;
                              padding-left: 15px;
                              padding-right: 15px;
                              padding-top: 10px
                              cursor: default;
                              margin-top: 5px;
                              background: #ffffff30;
                              color: #fff;
                            "
                            class="mx-1"
                          >
                            <span
                              class="mr-1"
                              style="
                                width: 7px;
                                height: 7px;
                                background: #ea5455;
                                border-radius: 50%;
                                display: inline-block;
                              "
                            ></span>
                            <span class="font-weight-bold pb-2"
                              >Limit Stream
                            </span>
                            <span> {{ camera.limit }}</span>
                          </vs-button>
                        </vs-col>
                      </vs-row>
                    </div>
                    <div id="imgVideo" class="w-full center-div"></div>
                    <vue-flv-player
                      :width="camera.width"
                      :height="camera.height"
                      :autoplay="camera.autoplay"
                      :controls="false"
                      :type="camera.type"
                      ref="myPlayer"
                      :muted="camera.sound"
                      :preload="false"
                      :source="camera.src"
                      :config="camera.media"
                      :mediaDataSource="camera.data_source"
                      class="w-full h-full"
                    />
                    <vs-row style="margin-top: -5rem">
                      <vs-col vs-type="flex" vs-w="12">
                        <vs-slider max="0" step="62" class="mx-3" />
                      </vs-col>
                    </vs-row>
                    <vs-row style="margin-top: -0.7rem">
                      <vs-col
                        vs-type="flex"
                        vs-justify="left"
                        vs-w="5"
                        class="pl-2"
                      >
                        <vs-button
                          color="primary"
                          type="filled"
                          icon-pack="feather"
                          icon="icon-chevrons-left"
                          @click="prevFile()"
                          class="mx-1"
                          style="margin-top: 5px"
                          :disabled="camera.disabled.prev"
                        >
                        </vs-button>
                        <vs-button
                          color="primary"
                          type="filled"
                          icon-pack="feather"
                          :icon="
                            camera.control == 'play'
                              ? 'icon-pause'
                              : 'icon-play'
                          "
                          @click="control()"
                          class="mx-1"
                          style="margin-top: 5px"
                          :disabled="camera.disabled.control"
                        >
                        </vs-button>
                        <vs-button
                          color="primary"
                          type="filled"
                          icon-pack="feather"
                          icon="icon-chevrons-right"
                          @click="nextFile()"
                          class="mx-1"
                          style="margin-top: 5px"
                          :disabled="camera.disabled.next"
                        >
                        </vs-button>
                        <vs-button
                          color="white"
                          text-color="#4B465C"
                          type="filled"
                          style="
                            font-size: 0.8em;
                            height: 25px;
                            line-height: 5pt;
                            padding-left: 15px;
                            padding-right: 15px;
                            padding-top: 10px
                            cursor: default;
                            margin-top: 5px;
                          "
                          class="mx-1"
                          v-show="!isSmallerScreen"
                        >
                          <span
                            class="font-weight-bold"
                            style="font-size: 1.1em"
                            >Time</span
                          >
                          <span> : {{ camera.timeSlider }}</span>
                        </vs-button>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        vs-justify="right"
                        vs-w="7"
                        class="pr-2"
                      >
                        <vs-button
                          color="white"
                          text-color="#4B465C"
                          type="filled"
                          style="
                            font-size: 0.8em;
                            height: 25px;
                            line-height: 5pt;
                            padding-left: 15px;
                            padding-right: 15px;
                            padding-top: 10px
                            cursor: default;
                            margin-top: 5px;
                          "
                          class="mx-1"
                          v-show="!isSmallerScreen"
                        >
                          <span
                            class="mr-1"
                            style="
                              width: 7px;
                              height: 7px;
                              background: #ea5455;
                              border-radius: 50%;
                              display: inline-block;
                            "
                          ></span>
                          <span class="font-weight-bold pb-2"
                            >Limit Stream
                          </span>
                          <span> {{ camera.limit }}</span>
                        </vs-button>
                        <vs-button
                          color="primary"
                          type="filled"
                          icon-pack="feather"
                          icon="icon-download"
                          class="mx-1"
                          style="
                            margin-top: 5px;
                            height: 25px;
                            font-size: 0.8em;
                            padding-left: 15px;
                            padding-right: 15px;
                          "
                          :disabled="camera.disabled.download"
                          @click="downloadVideo"
                        >
                          Download
                        </vs-button>
                        <vs-button
                          color="primary"
                          type="filled"
                          icon-pack="feather"
                          :icon="
                            camera.sound ? 'icon-volume-x' : 'icon-volume-1'
                          "
                          @click="handleSound()"
                          class="mx-1"
                          style="margin-top: 5px"
                          :disabled="camera.disabled.sound"
                        >
                        </vs-button>
                        <vs-button
                          color="primary"
                          type="filled"
                          size="small"
                          icon-pack="feather"
                          icon="icon-maximize"
                          class="mx-1"
                          style="margin-top: 5px"
                          @click="toggle()"
                          :disabled="camera.disabled.screen"
                        >
                        </vs-button>
                      </vs-col>
                    </vs-row>
                  </fullscreen>
                </vs-col>
              </vs-row>
            </vs-card>
          </vs-col>

          <vs-col
            type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="4"
            vs-sm="12"
          >
            <div class="vx-card p-3 ml-lg-3 mr-md-0">
              <l-map
                ref="peta"
                class="map"
                :center.sync="map.center"
                :zoom="map.zoom"
                :options="mapOptions"
                style="border-radius: 8px"
                :style="!isSmallerScreen ? `height: 73vh` : `height: 60vh`"
              >
                <l-tile-layer
                  v-for="tileProvider in tileProviders"
                  :key="tileProvider.name"
                  :name="tileProvider.name"
                  :visible="tileProvider.visible"
                  :url="tileProvider.url"
                  :attribution="tileProvider.attribution"
                  layer-type="base"
                  :options="{ maxZoom: 22 }"
                />
                <l-control-layers position="topright"></l-control-layers>

                <l-polyline
                  :lat-lngs="polyline.latlngs"
                  :color="polyline.color"
                  :weight="polyline.weight"
                ></l-polyline>

                <!-- Start Sign -->
                <l-marker
                  v-if="polyline.latlngs.length > 0"
                  :lat-lng="markerStart.position"
                  :icon="markerStart.icon"
                  :visible="markerStart.visible"
                />
                <!-- Finish Sign -->
                <l-marker
                  v-if="polyline.latlngs.length > 0"
                  :lat-lng="markerFinish.position"
                  :icon="markerFinish.icon"
                  :visible="markerFinish.visible"
                />
              </l-map>
            </div>
          </vs-col>

          <!-- <vs-col
            type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="3"
            vs-sm="12"
            v-if="loading"
          >
            <vs-card
              class="p-1 w-full h-full ml-lg-3 mr-md-0 skeleton-list"
              :class="isSmallerScreen ? 'mt-5' : 'mt-0'"
            >
              <b-skeleton
                animation="fade"
                width="100%"
                class="mb-5"
              ></b-skeleton>
              <div :key="index" v-for="(col, index) in 10">
                <b-skeleton
                  animation="fade"
                  type="avatar"
                  class="my-2 mr-2"
                  style="display: inline-block"
                ></b-skeleton>
                <b-skeleton
                  animation="fade"
                  width="50%"
                  class="my-2"
                  style="display: inline-block"
                ></b-skeleton>
              </div>
            </vs-card>
          </vs-col>
          <vs-col
            type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="3"
            vs-sm="12"
            v-else
          >
            <vs-card
              class="p-1 w-full h-full ml-lg-3 mr-md-0 skeleton-list"
              :class="isSmallerScreen ? 'mt-5' : 'mt-0'"
            >
              <vs-row type="flex" vs-justify="space-between">
                <vs-col vs-w="6" class="pr-2">
                  <label>Time Start</label>
                  <flat-pickr
                    :config="{
                      enableTime: true,
                      enableSeconds: true,
                      noCalendar: true,
                      dateFormat: 'H:i:S',
                      time_24hr: true,
                      minuteIncrement: 1,
                      secondIncrement: 1
                    }"
                    style="width: 100%; padding: 0.4rem; font-size: 0.8rem"
                    placeholder="Select time ..."
                    v-model="time_start"
                  />
                </vs-col>
                <vs-col vs-w="6" class="pl-2">
                  <label>Time End</label>
                  <flat-pickr
                    :config="{
                      enableTime: true,
                      enableSeconds: true,
                      noCalendar: true,
                      dateFormat: 'H:i:S',
                      time_24hr: true,
                      minuteIncrement: 1,
                      secondIncrement: 1
                    }"
                    style="width: 100%; padding: 0.4rem; font-size: 0.8rem"
                    placeholder="Select time ..."
                    v-model="time_end"
                  />
                </vs-col>
              </vs-row>
              <vs-row
                vs-align="flex-start"
                vs-type="flex"
                vs-justify="center"
                class="mt-2"
              >
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="12"
                >
                  <b-button
                    size="sm"
                    variant="primary"
                    style="border-radius: 5px 0 0 5px"
                    :style="
                      btn_group1
                        ? 'background: rgba(var(--vs-primary),1)!important; border-color: rgba(var(--vs-primary),1)!important; color: #ffffff'
                        : 'background: #F8F7FA; border-color: #F8F7FA; color:#4B465C;'
                    "
                    :pressed="btn_group1"
                    class="w-full group-button-cam"
                    @click="handleCam(0)"
                  >
                    Cam 1
                  </b-button>
                  <b-button
                    size="sm"
                    variant="secondary"
                    style="border-radius: 0 5px 5px 0"
                    :style="
                      btn_group2
                        ? 'background: rgba(var(--vs-primary),1)!important; border-color: rgba(var(--vs-primary),1)!important; color: #ffffff'
                        : 'background: #F8F7FA; border-color: #F8F7FA; color:#4B465C;'
                    "
                    :pressed="btn_group2"
                    class="w-full group-button-cam"
                    @click="handleCam(1)"
                  >
                    Cam 2
                  </b-button>
                </vs-col>
              </vs-row>
              <div
                class="mt-2"
                style="overflow-y: scroll"
                :style="
                  isSmallerScreen ? 'max-height: 90vh;' : 'max-height: 50vh; '
                "
              >
                <vs-row v-for="(item, index) in filelist" :key="index">
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="left"
                    vs-w="12"
                  >
                    <div
                      class="w-full card-time"
                      @click="handleCardClick(index)"
                      style="cursor: pointer"
                    >
                      <vs-card class="p-1 w-full mt-2 mb-0">
                        <b-form-radio
                          name="radio-size"
                          style="font-weight: bold; cursor: pointer"
                          v-model="selectedTime"
                          :value="index"
                        >
                          {{ item.time }}
                        </b-form-radio>
                      </vs-card>
                    </div>
                  </vs-col>
                </vs-row>
              </div>
            </vs-card>
          </vs-col> -->
        </vs-row>
      </div>
    </div>
  </div>
</template>

<style>
.dashcam-history .vs-card--content {
  margin-bottom: 0;
  height: 100% !important;
}

.dashcam-history .video-view {
  width: 100%;
  max-width: 1280px;
  height: 900px;
}

.dashcam-history .center {
  margin: auto;
}

.dashcam-history .center-div {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  width: 100%;
}

.dashcam-history .bg-video {
  background: #0b0b0b;
}

.dashcam-history .vs-slider-primary .vs-circles-slider {
  border: 4px solid rgba(var(--vs-primary), 1);
}

.dashcam-history .vs-slider--circle {
  width: 20px;
  height: 20px;
  top: -7px;
  margin-left: 0.7rem;
}

.dashcam-history .vs-slider {
  height: 6px;
}

.dashcam-history .includeIconOnly {
  width: 25px !important;
  height: 25px !important;
}

.dashcam-history .vs-slider--circles.isEndValue {
  border-radius: 50% !important;
}

.dashcam-history .not-zero .vs-slider--circles.isEndValue {
  margin-left: -0.7rem !important;
}

.dashcam-history .skeleton-list .b-skeleton-avatar {
  width: 1rem;
  height: 1rem;
}

.dashcam-history .vs-con-input-label {
  width: auto;
}

.dashcam-history .group-button-cam:focus {
  box-shadow: none !important;
}

.dashcam-history .custom-control-label {
  padding-top: 3px;
}

.dashcam-history .card-time .custom-control-label {
  cursor: pointer;
}
</style>

<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import L from 'leaflet'
import {
  LMap,
  LTileLayer,
  LMarker,
  LTooltip,
  LControlLayers,
  LControl,
  LPolyline
} from 'vue2-leaflet'
import LRotatedMarker from 'vue2-leaflet-rotatedmarker'
import { Icon } from 'leaflet'

import 'leaflet/dist/leaflet.css'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowSize: [0, 0],
  iconSize: [20, 30]
})

export default {
  components: {
    flatPickr,
    vSelect,
    LMap,
    LControl,
    LTileLayer,
    LMarker,
    LTooltip,
    LControlLayers,
    LRotatedMarker,
    LPolyline
  },

  data() {
    return {
      data: [],
      actor: {},
      token: '',

      tileProviders: [
        {
          name: 'Google Street',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=m@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Satellites',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Hybrid',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s,h@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Terrain',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=p@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Traffic',
          visible: true,
          url: 'https://www.google.com/maps/vt?lyrs=m@221097413,traffic&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          attribution:
            '&copy; <a target="_blank" href="https://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        }
      ],
      map: {
        center: L.latLng(-6.21011, 106.832459), //-1.041276, 122.288486
        zoom: 12
      },
      mapOptions: {
        // zoomSnap: 0.5
      },

      showFlieList: false,
      btn_show1: true,
      btn_show2: false,

      gps: {},

      tracks: [],
      trackType: 'line',
      polyline: {
        latlngs: [],
        color: 'purple',
        weight: 5
      },

      markerStart: {
        position: L.latLng(0, 0),
        icon: L.icon({
          iconUrl: process.env.BASE_URL + 'markers/start.png',
          iconSize: [50, 50],
          iconAnchor: [25, 48]
        }),
        visible: false
      },

      markerFinish: {
        position: L.latLng(0, 0),
        icon: L.icon({
          iconUrl: process.env.BASE_URL + 'markers/finish.png',
          iconSize: [50, 50],
          iconAnchor: [25, 48]
        }),
        visible: false
      },

      selected: [],
      time_start: '00:00:00',
      time_end: '23:59:59',
      btn_group1: true,
      btn_group2: false,
      selectedTime: 0,

      skeleton: false,
      loading: true,
      deviceList: [],

      device: '',
      maxDate: '',
      twoDaysAgo: '',
      date: null,
      disableDate: true,
      disabledSearch: true,
      filelist: [],
      filelist1: [],
      filelist2: [],

      channel: {
        disabled: true,
        val: ''
      },

      page: 1,
      per_page: 50,
      keyword: '',
      timer: null,
      counter: 0,

      notify: 'Server Error',

      interval: '',
      playVideo: false,

      camera: {
        counter: 0,
        limit_over: true,
        current_time_video: 0,
        limit: '00:00:00',
        limitSec: 0,
        live_sec: 0,
        imei: '',
        sound: false,
        timeoutSlider: null,
        tiemoutEndSlider: null,
        width: 160,
        height: 90,
        start: false,
        slider: 0,
        maxSlider: 0,
        currentFile: 0,
        switch_video: 0,
        video: false,
        control: 'pause',
        volume: 'mute',
        type: 'flv',
        src: '',
        timeStart: '',
        timeEnd: '',
        cmd: 'REPLAYLIST',
        disabled: {
          prev: false,
          control: false,
          next: false,
          slider: false,
          sound: false,
          screen: false
        },
        data_source: {
          duration: 10
        },
        media: {
          volume: 0,
          isLive: true,
          stashInitialSize: 1000,
          SourceBuffer: true
        },
        timeSlider: '00:00:00',
        date: ''
      },

      config: {
        isLive: true,
        autoCleanupSourceBuffer: true,
        autoCleanupMaxBackwardDuration: 60
      },

      vehicle: {
        device_name: '',
        visible: false,
        imei: '',
        lon: 0,
        lat: 0,
        position: L.latLng(-6.21011, 106.832459),
        is_expired: false,
        server_time: '1970-01-01 00:00:00',
        alert: 0,
        acc: 0,
        speed: 0,
        angle: 0,
        time: '1970-01-01 00:00:00',
        icons: '',
        icon: {
          color: 'parking',
          value: 0,
          parking: '',
          label: '',
          acc_on: '',
          lost: '',
          alarm: ''
        }
      },

      fullscreen: false,
      date_selected: '',
      is_disable_cam2: false,
      client_ip: ''
    }
  },

  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 992
    },

    isWider() {
      return this.$store.state.windowWidth >= 1440
    }
  },

  watch: {
    time_start() {
      this.handleTime()
    },

    time_end() {
      this.handleTime()
    },

    selectedTime() {
      this.camera.currentFile = this.selectedTime
    },

    device: {
      handler(val) {
        if (val) {
          this.channel.list = this.cameraList
          this.channel.disabled = false
          this.disableDate = false
        } else {
          this.channel.list = []
          this.channel.disabled = true
          this.disableDate = true
        }
        this.disabledSearch = true
        this.date = ''
      }
    },

    date: {
      handler() {
        this.handleDisabledSearch()
      }
    },

    playVideo() {
      let player = this.$refs['myPlayer'].$refs.flvPlayer
      if (this.camera.control == 'play' && this.playVideo) {
        this.interval = setInterval(() => {
          let getDate = this.convertDateTime(this.camera.timeEnd, 1)
          this.camera.timeEnd = getDate[0] + ' ' + getDate[1]

          if (this.camera.limitSec <= 0 || this.camera.limit_over) {
            this.limitOver()
            return
          }

          if (player.currentTime == this.camera.current_time_video) {
            this.camera.counter = this.camera.counter + 1
            this.buffering()
          } else {
            let sec = this.camera.limitSec - 1

            this.$vs.loading.close(`#imgVideo > .con-vs-loading`)
            this.camera = {
              ...this.camera,
              counter: 0,
              live_sec: this.camera.live_sec + 1,
              limitSec: sec,
              limit: this.convertTime(sec)
            }
          }

          if (player.ended || this.camera.counter >= 15) {
            this.videoEnded(true)
            return
          }

          if (
            !isNaN(Math.round(player.duration)) &&
            player.currentTime != this.camera.current_time_video
          )
            this.camera.timeSlider = this.convertDateTime(
              this.camera.date + ' ' + this.camera.timeSlider,
              1
            )[1]

          this.camera.current_time_video = player.currentTime

          this.controlDisabled()
        }, 1000)
      } else {
        if (this.interval) clearInterval(this.interval)
      }
    }
  },

  created() {
    if (localStorage.getItem('isGenerate') == 'true') {
      window.location.href = process.env.BASE_URL + 'error-404'
    }

    let today = new Date()
    this.today = this.formatDate(today.toDateString())
    this.maxDate = this.today

    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''
    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })

    window.addEventListener('beforeunload', () => {
      this.saveLogStreaming()
    })
  },

  mounted() {
    this.client_ip = JSON.parse(localStorage.getItem('client_ip'))
  },

  beforeMounted() {
    this.saveLogStreaming()
  },

  methods: {
    downloadVideo() {
      if (this.camera.src == '') {
        return this.$vs.notify({
          title: 'Notification',
          text: 'The video has ended, Please Re-play to download.',
          color: 'danger',
          position: 'top-right'
        })
      }

      window.open(this.camera.src, '_blank')

      // if (this.camera.control == 'play' && this.playVideo) {
      //   let player = this.$refs['myPlayer'].$refs.flvPlayer
      //   let currentTime = player.currentTime
      //   player.download({ startTime: currentTime })
      // }
    },

    handleTime() {
      let data = this.camera.switch_video ? this.filelist2 : this.filelist1

      let filter = data.filter((item) => {
        let time = item.time
        return time >= this.time_start && time <= this.time_end
      })

      this.filelist = filter
      this.controlDisabled()
    },

    handleCardClick(value) {
      // this.selectedTime = value
      this.camera.currentFile = value
      this.getTrack()
      this.controlFile()
      // this.handleVideo()
    },

    handleCam(value) {
      if (value) {
        this.btn_group1 = false
        this.btn_group2 = true
        this.filelist = this.filelist2
      } else {
        this.btn_group1 = true
        this.btn_group2 = false
        this.filelist = this.filelist1
      }
      this.camera.switch_video = value
      this.controlDisabled()
      this.controlFile()
    },

    handleFileList(value) {
      if (value) {
        this.btn_show1 = false
        this.btn_show2 = true
      } else {
        this.btn_show1 = true
        this.btn_show2 = false
      }
      this.showFlieList = value
    },

    handleDisabledSearch() {
      this.date ? (this.disabledSearch = false) : (this.disabledSearch = true)
    },

    searchDevice(keyword) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.getDataDevice(keyword)
      }, 500)
    },

    getDataDevice(keyword) {
      let config = {
        headers: { Authorization: `Bearer ${this.token}` },
        params: {
          page: 1,
          per_page: 50,
          search: keyword
        }
      }

      this.$http
        .get(`${this.$api.endpoint}/gps/datatable_dashcam`, config)
        .then((res) => {
          this.deviceList = res.data.data.data_list
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('-')
    },

    control() {
      if (this.camera.video) {
        this.camera.counter = 0
        this.playVideo = false

        if (this.camera.limitSec <= 0 || this.camera.limit_over) {
          this.limitOver()
          return
        }

        if (this.camera.start) {
          if (this.camera.control == 'play') {
            this.playVideo = false
            this.camera.control = 'pause'
            this.$refs['myPlayer'].pause()
            clearInterval(this.interval)
          } else {
            setTimeout(() => {
              this.playVideo = true
              this.camera.control = 'play'
              this.$refs['myPlayer'].play()
            }, 50)
          }
        } else {
          this.camera = {
            ...this.camera,
            control: 'play',
            disabled: {
              prev: true,
              control: true,
              next: true,
              slider: true,
              sound: true,
              screen: true
            }
          }

          let cmd = 'REPLAYLIST,' + this.filelist[this.camera.currentFile].file
          let params = {
            imei: this.camera.imei,
            command: cmd
          }

          this.$http
            .post(`${this.$api.endpoint}/dashcam/connect`, params)
            .then((res) => {
              let response = res.data.data

              this.camera = {
                ...this.camera,
                cmd: cmd,
                limit: this.convertTime(response.limit_live),
                limitSec: response.limit_live,
                src:
                  this.$api.connect_iothub +
                  '/live/' +
                  this.camera.imei +
                  '.flv',
                timeSlider: this.filelist[this.camera.currentFile].time,
                autoplay: true,
                start: true,
                control: 'play'
              }
              this.playVideo = true
            })
            .catch((error) => {
              this.camera = {
                ...this.camera,
                start: false,
                control: 'pause',
                src: ''
              }

              this.notify = 'Server Error'
              if (typeof error.response.data.message !== undefined) {
                this.notify = error.response.data.message.split('_').join(' ')
              }
              this.$gf.httpErrorHandler(error)
            })
            .finally(() => {
              this.camera = {
                ...this.camera,
                disabled: {
                  prev: false,
                  control: false,
                  next: false,
                  slider: false,
                  sound: false,
                  screen: false
                }
              }
            })
        }
      } else this.camera.control = 'pause'
    },

    prevFile() {
      this.camera.currentFile--
      this.getTrack()
      this.controlFile()
    },

    nextFile() {
      this.camera.currentFile++
      this.getTrack()
      this.controlFile()
    },

    controlFile() {
      this.selectedTime = this.camera.currentFile
      this.handleVideo()
      this.controlDisabled()
    },

    handleVideo() {
      if (this.interval) this.$refs['myPlayer'].destroy()
      this.playVideo = false
      clearInterval(this.interval)
      this.saveLogStreaming()

      this.camera = {
        ...this.camera,
        src: '',
        disabled: {
          prev: true,
          control: true,
          next: true,
          slider: true
        }
      }

      let cmd = 'REPLAYLIST,' + this.filelist[this.camera.currentFile].file

      let params = {
        imei: this.camera.imei,
        command: cmd
      }

      this.$http
        .post(`${this.$api.endpoint}/dashcam/connect`, params)
        .then((res) => {
          let response = res.data.data
          this.camera = {
            ...this.camera,
            cmd: cmd,
            limit: this.convertTime(response.limit_live),
            limitSec: response.limit_live,
            src:
              this.$api.connect_iothub + '/live/' + this.camera.imei + '.flv',
            timeSlider: this.filelist[this.camera.currentFile].time,
            autoplay: false,
            control: 'pause',
            start: true,
            disabled: {
              prev: false,
              control: false,
              next: false,
              slider: false
            }
          }

          this.controlDisabled()
        })
        .catch((error) => {
          this.notify = 'Server Error'
          if (typeof error.response.data.message !== undefined) {
            this.notify = error.response.data.message.split('_').join(' ')
          }
          this.$gf.httpErrorHandler(error)
          this.camera = {
            ...this.camera,
            control: 'pause',
            disabled: {
              prev: false,
              control: false,
              next: false,
              slider: false
            }
          }
        })
    },

    controlDisabled() {
      setTimeout(() => {
        this.camera.disabled.prev = !this.camera.currentFile ? true : false
        this.camera.disabled.next =
          this.camera.currentFile + 1 == this.filelist.length ? true : false
      }, 50)
    },

    toggle() {
      this.fullscreen = !this.fullscreen
    },

    search() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#searchBtn',
        scale: 0.45
      })
      this.skeleton = true
      this.loading = true

      this.btn_group1 = true
      this.btn_group2 = false

      this.selectedTime = 0

      this.stopVideo(true)
      this.disabledSearch = true
      this.camera = {
        ...this.camera,
        control: 'pause',
        src: '',
        start: false,
        video: false
      }

      let params = {
        imei: this.device.imei,
        date: this.date,
        isWeb: true
      }

      this.$http
        .post(`${this.$api.endpoint}/dashcam/store_camera`, params)
        .then(() => {
          let config = {
            headers: {
              Authorization: `Bearer ${this.token}`
            },
            params
          }

          setTimeout(() => {
            this.$http
              .get(`${this.$api.endpoint}/dashcam/connect_history`, config)
              .then((res) => {
                let response = res.data.data
                let getDate = this.convertDateTime(new Date(), 0)
                let getDateTime = getDate[0] + ' ' + getDate[1]
                this.time_start = '00:00:00'
                this.time_end = '23:59:59'
                this.filelist1 = response.filelist_camera1.list_file
                this.filelist2 = response.filelist_camera2.list_file
                this.filelist = response.filelist_camera1.list_file
                this.camera = {
                  ...this.camera,
                  limit_over: false,
                  switch_video: 0,
                  video: true,
                  autoplay: false,
                  timeSlider: response.filelist_camera1.start_time,
                  imei: this.device.imei,
                  date: this.date,
                  currentFile: 0,
                  limit: this.convertTime(response.gps.limit_live),
                  limitSec: response.gps.limit_live,
                  timeStart: getDateTime,
                  timeEnd: getDateTime
                }
                this.camera.disabled.prev = true
                this.date_selected = this.date

                this.getTrack()
                this.handleFileList(1)

                if (this.device.total_camera && this.device.total_camera > 1)
                  this.is_disable_cam2 = false
                else {
                  this.is_disable_cam2 = true
                  this.handleCam(0)
                }

                this.$vs.loading.close(`#searchBtn > .con-vs-loading`)

                this.$vs.notify({
                  title: 'Success',
                  text: res.data.message,
                  color: 'success',
                  position: 'top-right'
                })
              })
              .catch((error) => {
                this.notify = 'Server Error'
                if (typeof error.response.data.message !== undefined) {
                  this.notify = error.response.data.message.split('_').join(' ')
                }
                this.$gf.httpErrorHandler(error)
                this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
                this.skeleton = false
              })
              .finally(() => {
                this.disabledSearch = false
                this.loading = false
              })
          }, 2000)
        })
        .catch((error) => {
          this.notify = 'Server Error'
          if (typeof error.response.data.message !== undefined) {
            this.notify = error.response.data.message.split('_').join(' ')
          }
          this.$gf.httpErrorHandler(error)
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
          this.disabledSearch = false
          this.skeleton = false
          this.loading = false
        })
    },

    stopVideo(storeLog) {
      clearInterval(this.interval)
      this.playVideo = false
      if (storeLog) this.saveLogStreaming()
    },

    handleSound() {
      if (this.camera.video) {
        this.camera.sound = this.camera.sound ? false : true
      } else this.camera.sound = true
    },

    buffering() {
      this.$vs.loading({
        background: 'transparent',
        container: '#imgVideo',
        color: '#fff',
        scale: 1
      })
    },

    convertTime(totalSec) {
      const hour = Math.floor(totalSec / 3600)
      const minute = Math.floor((totalSec % 3600) / 60)
      const second = totalSec % 60
      const hours = hour < 10 ? '0' + hour : hour
      const minutes = minute < 10 ? '0' + minute : minute
      const seconds = second < 10 ? '0' + second : second

      const time = hours + ':' + minutes + ':' + seconds
      return time
    },

    convertDateTime(datetime, plusSec) {
      let time = new Date(datetime)
      time.setSeconds(time.getSeconds() + plusSec)
      let getMonth = parseInt(time.getMonth()) + 1
      let month = getMonth >= 10 ? getMonth : '0' + getMonth
      let date = time.getDate() >= 10 ? time.getDate() : '0' + time.getDate()
      let hour = time.getHours() >= 10 ? time.getHours() : '0' + time.getHours()
      let minute =
        time.getMinutes() >= 10 ? time.getMinutes() : '0' + time.getMinutes()
      let sec =
        time.getSeconds() >= 10 ? time.getSeconds() : '0' + time.getSeconds()
      let newDate = `${time.getFullYear()}-${month}-${date}`
      let newTime = `${hour}:${minute}:${sec}`
      return [newDate, newTime]
    },

    saveLogStreaming() {
      if (this.camera.timeStart != '' && this.camera.timeEnd != '') {
        let params = {
          start_date: this.camera.timeStart,
          end_date: this.camera.timeEnd,
          second_live: this.camera.live_sec,
          imei: this.camera.imei,
          action: 2,
          camera: this.camera.switch_video,
          cmd_content: this.camera.cmd,
          isWeb: true,
          client_ip: this.client_ip
        }

        this.$http
          .post(`${this.$api.endpoint}/dashcam/store_log_streaming`, params)
          .then(() => {
            this.counter = 0
            this.camera.cmd =
              'REPLAYLIST,' + this.filelist[this.camera.currentFile].file
            let getDate = this.convertDateTime(new Date(), 0)
            let getDateTime = getDate[0] + ' ' + getDate[1]
            this.camera = {
              ...this.camera,
              live_sec: 0,
              timeStart: getDateTime,
              timeEnd: getDateTime
            }
          })
          .catch(() => {
            if (this.counter <= 5) {
              setTimeout(() => {
                this.counter = this.counter + 1
                this.saveLogStreaming()
              }, 5000)
            }
          })
      }
    },

    limitOver() {
      this.$vs.notify({
        title: 'Notification',
        text: 'Your limit is up, Please Top up',
        color: 'danger',
        position: 'top-right'
      })

      if (!this.camera.limit_over) this.$refs['myPlayer'].destroy()

      clearInterval(this.interval)
      this.camera.control = 'pause'
      this.$vs.loading.close(`#imgVideo > .con-vs-loading`)
      this.saveLogStreaming()
      this.camera.limit_over = true
    },

    videoEnded() {
      this.controlDisabled()
      this.stopVideo(true)
      this.camera = {
        ...this.camera,
        start: false,
        slider: this.camera.maxSlider,
        control: 'pause',
        src: ''
      }
      this.interval = null
      this.$refs['myPlayer'].destroy()
      this.$vs.notify({
        title: 'Thank you',
        text: 'The video has ended.',
        color: 'primary',
        position: 'top-right'
      })

      setTimeout(() => {
        this.$vs.loading.close(`#imgVideo > .con-vs-loading`)
      }, 50)
    },

    getTrack() {
      let start_file = this.filelist[this.camera.currentFile].file.replaceAll(
        '_',
        '-'
      )

      let start_date =
        start_file.substring(0, 10) +
        ' ' +
        this.filelist[this.camera.currentFile].time

      let end_file =
        this.camera.currentFile == this.filelist.length - 1
          ? this.filelist[this.camera.currentFile].file.replaceAll('_', '-')
          : this.filelist[this.camera.currentFile + 1].file.replaceAll('_', '-')

      if (this.camera.currentFile == this.filelist.length - 1) {
        var end_date =
          end_file.substring(0, 10) +
          ' ' +
          this.filelist[this.camera.currentFile].time
      } else {
        var end_date =
          end_file.substring(0, 10) +
          ' ' +
          this.filelist[this.camera.currentFile + 1].time
      }

      this.polyline.latlngs = []
      this.tracks = []

      this.$http
        .get(`${this.$api.endpoint}/tracking/track/${this.device.imei}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            start: start_date,
            end: end_date
          }
        })
        .then((res) => {
          this.loading_map = false

          if (res.data.message.data.length > 0) {
            this.tracks = res.data.message.data

            // init start marker
            ;(this.markerStart.position = L.latLng(
              this.tracks[0].lat,
              this.tracks[0].lon
            )),
              (this.markerStart.visible = true)

            // init finish marker
            ;(this.markerFinish.position = L.latLng(
              this.tracks[this.tracks.length - 1].lat,
              this.tracks[this.tracks.length - 1].lon
            )),
              (this.markerFinish.visible = true)

            this.tracks.map((item, index) => {
              this.polyline.latlngs.push([item.lat, item.lon])
            })

            this.centerMap(this.tracks[0].lat, this.tracks[0].lon)
          }
        })
        .catch((error) => {
          console.log(error)
          this.loading_map = false
          this.$gf.httpErrorHandler(error)
        })
    },

    centerMap(lat, lon) {
      // this.map.center = L.latLng(lat, lon)
      // this.map.zoom = 18
      const newZoom = 14
      this.$refs.peta.mapObject.setView(L.latLng(lat, lon), newZoom)
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/extraComponents/tree.scss';
</style>
